import React, { useState, useEffect } from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import _ from 'lodash'
import { RegularButton, RegularButtonOutline, CheckButton } from '../../atoms'
import {matchPath, useLocation, useParams} from "react-router";
import routes from "../../../config/routes";
import {useAppContext} from "../../../context/appContext";
import {getCurrentSectionKey, SECTION_KEYS} from "../../../config/constants";
import * as FiltersUtils from "../../../utils/filters";
import { LoadingLabel } from '../action-dialog'

const Form = ({ module, ids, fields, filters, sort, onSubmit, onCancel, i18n, offerFilters }) => {

    const {savedSearchItems, filterGroup} = useAppContext();
    const location = useLocation();
    const {slug, savedSearchItemId} = useParams();
    const [ form, setForm ] = useState(null);
    const [ isSubmitting, setIsSubmitting ] = useState(false);

    useEffect(()=>{
        setForm(fields)
        // eslint-disable-next-line
    }, [])

    const handleClick = () => {
        let newFilter = {...filters}
        if (matchPath(location.pathname, {path: routes.offerCandidatures.replace(':slug', slug)})) {
            newFilter = {...offerFilters}
        }
        if (getCurrentSectionKey() === SECTION_KEYS.SAVED_SEARCHES_ITEM) {
            let strFilters = savedSearchItems && savedSearchItems[savedSearchItemId] ? savedSearchItems[savedSearchItemId].fields : null;
            let filters = strFilters ? JSON.parse(strFilters) : {};
            let filterGroupValue = filterGroup[getCurrentSectionKey()] && filterGroup[getCurrentSectionKey()][savedSearchItemId] ? filterGroup[getCurrentSectionKey()][savedSearchItemId] : null;

            newFilter = FiltersUtils.refactorSavedSearchFiltersByGroupSelected(filters, filterGroupValue);
        }
        if(ids && ids.length > 0) newFilter = {id: ids}
        const submitForm = _.map(form, (item) => item.remote_name)
        setIsSubmitting(true)
        onSubmit( submitForm, {...newFilter}, sort, module )
    }

    const handleChangeValue = e => {
        const newForm = [...form]
        if (e.target.checked) {
            newForm.push(_.find(fields, {remote_name: e.target.name}))
        } else {
            _.remove(newForm, (item) => { 
                return item.remote_name === e.target.name; 
            }); 
        }
        setForm(newForm)
    }
    const handleSelectAll = e => setForm(e.target.checked ? [...fields] : [])

    if(!form) return null
    return (
        <>
            {/* Como «Crear informe» de Informes: «Seleccionar todo» y cada campo como casilla con su
                nombre, en dos columnas, para que el modal no crezca tanto */}
            <CheckButton
                title={i18n.modalCreateReport.selectAll}
                strong
                checked={_.size(form) === _.size(fields)}
                onChange={handleSelectAll}
            />
            <div className="report-fields">
                {_.map(fields, ({ name, remote_name }) => (
                    <CheckButton
                        key={`mcr_${remote_name}`}
                        name={remote_name}
                        title={name}
                        checked={!!_.find(form, {remote_name})}
                        onChange={handleChangeValue}
                    />
                ))}
            </div>
            <div className="button-wrapper">
                {onCancel && <RegularButtonOutline type="button" title={i18n.dialog.decline} onClick={onCancel} />}
                <RegularButton disabled={_.isEmpty(form) || isSubmitting} title={<LoadingLabel loading={isSubmitting}>{i18n.modalCreateReport.createReport}</LoadingLabel>} onClick={handleClick} />
            </div>
        </>
    )
}

const enharce = compose(withI18n)

export default enharce(Form)